const fileDownloadButtonCompCalendar = {
  title: 'Gerar Relatório'
};

export default fileDownloadButtonCompCalendar;
